import { Record as record, List } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export var AuditSignature = record({
  description: null,
  signerFullname: null,
  signerUserId: null,
  successful: null,
  timestamp: null,
  comment: null,
  integrityOk: null
});

export var AuditSignatureShape = ImmutablePropTypes.recordOf({
  description: PropTypes.string,
  signerFullname: PropTypes.string,
  signerUserId: PropTypes.number,
  successful: PropTypes.bool,
  timestamp: PropTypes.number,
  comment: PropTypes.string,
  integrityOk: PropTypes.bool
});

export var AuditEntry = record({
  id: null,
  uuid: null,
  userName: null,
  loginUsername: null,
  companyName: null,
  date: null,
  officeName: null,
  action: null,
  status: null,
  ip: null,
  description: null,
  valueChanges: List,
  signature: AuditSignature,
  userId: null
});

AuditEntry.normalize = function (data) {
  var normalized = Object.assign({
    id: Math.random().toString(32).substring(2)
  }, data);

  return normalized;
};

export var AuditEntryShape = ImmutablePropTypes.recordOf({
  id: PropTypes.number,
  uuid: PropTypes.string,
  userName: PropTypes.string,
  companyName: PropTypes.string,
  date: PropTypes.number,
  officeName: PropTypes.string,
  action: PropTypes.string,
  status: PropTypes.string,
  ip: PropTypes.string,
  description: PropTypes.string,
  valueChanges: ImmutablePropTypes.listOf(PropTypes.shape({
    fieldName: PropTypes.string,
    valueBefore: PropTypes.string,
    valueAfter: PropTypes.string
  })),
  signature: AuditSignatureShape,
  userId: PropTypes.number
});

export var AuditEntryShapeList = ImmutablePropTypes.listOf(AuditEntryShape);